import { APP_LOGIN } from '../../config/prod.env'
import http from '../utils/http'
// 
/**
//  *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
//  *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
// let resquest = "/testIp/request/"

// 接口请求
export default {
    // 图形验证码
    getVerifyCode(params) {
        return http.post(`${process.env.API_PATH}${process.env.GET_VERIFY_CODE}`,params)
    },
    // 短信验证码
    getSMSCode(params){
        return http.post(`${process.env.API_PATH}${process.env.GET_SMS_CODE}`,params)
    },
    // 登录
    login(params) {
        return http.post(`${process.env.API_PATH}${process.env.POST_LOGIN}`, params)
    },
    // 用户退出登录
    logout(params) {
        return http.post(`${process.env.API_PATH}${process.env.LOGOUT}`, params)
    },
    // 获取用户手机号
    getContact(params){
        return http.post(`${process.env.API_PATH}${process.env.GET_CONTACT}`, params)
    },
    // 订阅页
    getPlan(params) {
        return http.post(`${process.env.API_PATH}${process.env.GET_PLAN}`, params)
    },
    // 查看商品详情
    plan_detail(params){
        return http.post(`${process.env.API_PATH}${process.env.PLAN_DETAIL}`,params)
    },
    // 付费方案
    payment_plan(params){
        return http.post(`${process.env.API_PATH}${process.env.PAYMENT_PLAN}`,params)
    },
    // 获取订单列表
    getOrderList(params){
        return http.post(`${process.env.API_PATH}${process.env.GET_ORDER_LIST}`,params)
    },
    // 取消订单
    cancel_order(params){
        return http.post(`${process.env.API_PATH}${process.env.CANCEL_ORDER}`,params)
    },
    // 重新支付
    reget_payment(params){
        return http.post(`${process.env.API_PATH}${process.env.REGET_PAYMENT}`,params)
    },
    // 获取服务
    getReservationList(params){
        return http.post(`${process.env.API_PATH}${process.env.GET_RESERVATION_LIST}`,params)
    },
    // 订单状态
    getOrderStatus(params) {
        return http.post(`${process.env.API_PATH}${process.env.GET_ORDER_STATUS}`, params)
    },
    // 发表评价
    setComment(params) {
        return http.post(`${process.env.API_PATH}${process.env.SET_COMMENT}`,params)
    },
    // 获取评价
    GetComment(params) {
        return http.post(`${process.env.API_PATH}${process.env.GET_COMMENT}`,params)
    },
    // 申请退款
    user_refund(params){
        return http.post(`${process.env.API_PATH}${process.env.USER_REFUND}`,params)
    },
    // 调试优化
    user_reSetup(params){
        return http.post(`${process.env.API_PATH}${process.env.USER_RESETUP}`,params)
    },
    // 服务商
    // 服务商图形验证码
    accountGetVerifyCode(params) {
        return http.post(`${process.env.API_PATH}${process.env.ACCOUNT_GET_VERIFY_CODE}`,params)
    },
    // 服务商登录
    accountLogin(params) {
        return http.post(`${process.env.API_PATH}${process.env.ACCOUNT_LOGIN}`, params)
    },
    // 服务商退出登录
    accountLogout(params) {
        return http.post(`${process.env.API_PATH}${process.env.ACCOUNT_LOGOUT}`, params)
    },
    // 获取服务列表
    getServerReservationList(params){
        return http.post(`${process.env.API_PATH}${process.env.GET_SERVER_RESERVATION_LIST}`, params)
    },
    // 确定服务
    reserve(params){
        return http.post(`${process.env.API_PATH}${process.env.RESERVE}`, params)
    },
    // 开始服务
    startService(params){
        return http.post(`${process.env.API_PATH}${process.env.STARTSERVICE}`, params)
    },
    // 修改服务
    changeReservation(params){
        return http.post(`${process.env.API_PATH}${process.env.CHANGERESERVE}`, params)
    },
    // 获取核销链接
    getVerificationLink(params){
        return http.post(`${process.env.API_PATH}${process.env.GET_VERIFICATION_LINK}`, params)
    },
    // 获取核销链接
    setVerificationLink(params){
        return http.post(`${process.env.API_PATH}${process.env.SET_VERIFICATION_LINK}`, params)
    },
    // 本地核销
    verification(params){
        return http.post(`${process.env.API_PATH}${process.env.VERIFICATION}`, params)
    },
    // 链接核销
    activeVerificationLink(params){
        return http.post(`${process.env.API_PATH}${process.env.ACTIVE_VERIFICATION_LINK}`, params)
    },
    // 获取单个评价
    vendorGetComment(params){
        return http.post(`${process.env.API_PATH}${process.env.VENDOR_GET_COMMENT}`, params)
    },
    // 获取service服务产品
    getService(params){
        return http.post(`${process.env.API_PATH}${process.env.GETSERVICE}`, params)
    },
    // 服务人员列表
    getEngineers(params){
        return http.post(`${process.env.API_PATH}${process.env.GETENGINEERS}`, params)
    },
    addEngineer(params){
        return http.post(`${process.env.API_PATH}${process.env.ADDENGINEERS}`, params)
    },
    delEngineer(params){
        return http.post(`${process.env.API_PATH}${process.env.DELENGINEERS}`, params)
    },
    // find
    findReservation(params){
        return http.post(`${process.env.API_PATH}${process.env.FINDRESERVATION}`, params)
    },
    // 导出
    ExportReservation(params){
        return http.post(`${process.env.API_PATH}${process.env.EXPORTRESERVATION}`, params)
    },
    GetExportStatus(params){
        return http.post(`${process.env.API_PATH}${process.env.GETEXPORTSTATUS}`, params)
    },
    // 完成再次精调
    closeReSetup(params){
        return http.post(`${process.env.API_PATH}${process.env.CLOSERESETUP}`, params)
    },
    // 关闭服务
    changeReservation(params){
        return http.post(`${process.env.API_PATH}${process.env.CHANGERESERVATION}`, params)
    },
    // 获取上传url
    getUploadQAFileURL(params){
        return http.post(`${process.env.API_PATH}${process.env.GETUPLOADQAFILEURL}`, params)
    },
    // 获取上传状态
    checkQAFileStatus(params){
        return http.post(`${process.env.API_PATH}${process.env.CHECKQAFULESTATUS}`, params)
    },
    // 修改密码
    changePassord(params){
        return http.post(`${process.env.API_PATH}${process.env.CHANGEPASSWORD}`, params)
    },
    // 申请调试完毕
    noCodeVerification(params){
        return http.post(`${process.env.API_PATH}${process.env.NOCODEVERIFICATION}`, params)
    }
}


// WEBPACK FOOTER //
// ./src/api/api.js